import React, { useState, useCallback } from 'react'

import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'
import Img from 'gatsby-image'

import Aside from '@/components/Aside'
import Questions from '@/components/Questions'
import Sponsors from '@/components/Sponsors'
import LoginOrRegister from '@/components/LoginOrRegister'
import Banner from '@/components/Banner'

import { StParagraphs, StAvatar, StSep1, StOverlay } from './style.css'

import styled from 'styled-components'

const StCredits = styled.div`
  border: 1px solid #ccc;
  padding: 2rem;
  margin: 1rem auto;
  max-width: 800px;
  text-align: center;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 1rem 2rem;
  }
  .auspicio {
    border-bottom: 2px solid #ccc;
    margin-bottom: 2rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    .col1 {
      justify-self: flex-end;
      font-size: 1.8rem;
    }
    .col2 {
      justify-self: flex-start;
    }
    img {
      min-height: 100px;
      min-width: 300px;
      @media (max-width: 800px) {
        min-width: 240px;
      }
    }
    @media (max-width: 800px) {
      grid-template-columns: 1fr;
      .col1 {
        justify-self: center;
      }
      .col2 {
        justify-self: center;
      }
    }
  }
  .gremios {
    img {
      display: block;
      max-width: 100%;
      margin: 1rem auto;
    }
  }
`

const LogoHeight = styled.div`
  margin-bottom: 1rem;

  img {
    display: block;
    max-height: 3rem;
    max-width: 8rem;
    margin-left: auto;
    margin-right: auto;
  }
`

const Webinar = ({
  title,
  downtitle,
  video,
  author,
  aside,
  webinarmeta,
  webinarid,
  banner,
  bannerhtml,
  sponsors,
  survey,
}) => {
  // const { fullname, bio, avatar } = author
  const { description } = video
  const { start, end, about, place, promovideo } = webinarmeta

  const event = {
    id: webinarid,
    startTime: start,
    endTime: end,
    location: place,
    title: title,
    description: description,
  }

  const htmldescription = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(description)
    .toString()

  const htmlabout = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(about)
    .toString()

  const htmlbanner = remark()
    .use(recommended)
    .use(remarkHtml)
    .processSync(bannerhtml)
    .toString()

  const inserter = (originalString, insertText, textToSearch) => {
    const position = originalString.indexOf(textToSearch)
    if (position === -1) {
      return originalString
    }
    const pair = Array.from(originalString)
    pair.splice(position, 0, insertText)
    return pair.join('')
  }

  const toInsert = inserter(title, '<br />', downtitle)

  return (
    <div className="mx-auto text-left">
      <div className="grid grid-cols-12 mt-4 items-stretch">
        <div className="bg-gris-300 pt-4 sm:col-span-8 col-span-12 row-span-2">
          <div className="relative">
            <LoginOrRegister event={event} video={video} />
          </div>
          <div className="wrap-title sm:p-8 p-4 bg-gris-100">
            <h1 className="leading-none mb-6 text-2xl font-bold sm:text-4xl">
              {downtitle && title.indexOf(downtitle) !== -1 ? (
                <span dangerouslySetInnerHTML={{ __html: toInsert }}></span>
              ) : (
                <span> {title}</span>
              )}
            </h1>
            {author && author.length > 0 && (
              <div>
                {author.map((auth, index) => {
                  return (
                    <p key={index}>
                      <span className="font-bold">{auth.fullname}</span>
                      {auth.title && (
                        <small className="block">{auth.title}</small>
                      )}
                    </p>
                  )
                })}
              </div>
            )}
          </div>
        </div>
        <Questions
          className="bg-white sm:col-span-4 col-span-12 row-span-2"
          video={video}
          title={title}
          aside={aside}
          webinarid={webinarid}
          webinarmeta={webinarmeta}
          banner={banner}
          sponsors={sponsors}
          survey={survey}
          backgroundtype="clear"
        />
      </div>
      <Aside className="bg-white" data={aside} />
      <div className="grid grid-cols-12 mt-4">
        <div className="bg-white pt-4 sm:col-span-8 col-span-12">
          <StSep1>
            <h6 className="sm:px-8 px-4 py-2">
              <span className="font-bold block leading-tight">Detalles</span>{' '}
              <small className="block leading-none">Sobre el video</small>
            </h6>
          </StSep1>
          <div className="wrap-description sm:px-8 px-4 py-2">
            <StParagraphs
              className=""
              dangerouslySetInnerHTML={{ __html: htmlabout }}
            />
          </div>
          <StSep1>
            <h6 className="about-title sm:px-8 px-4 py-0 mt-4 uppercase">
              <small>Sobre los presentadores</small>
            </h6>
          </StSep1>
          {author && author.length > 0 && (
            <div>
              {author.map((auth, index) => {
                const htmlbio = remark()
                  .use(recommended)
                  .use(remarkHtml)
                  .processSync(auth.bio)
                  .toString()
                return (
                  <div
                    key={index}
                    className="wrap-author grid grid-cols-8 sm:gap-4 gap-2 sm:px-8 px-2 pt-2 pb-8">
                    <div className="wrap-img sm:col-span-1 col-span-2">
                      <StAvatar>
                        <Img
                          className="rounded-full block"
                          fixed={auth.avatar.childImageSharp.fixed}
                        />
                      </StAvatar>
                    </div>
                    <div className="wrap-author-text sm:col-span-7 col-span-6">
                      <div key={index}>
                        <h4 className="font-bold">
                          {auth.fullname}{' '}
                          <small className="mb-4 block font-normal">
                            {auth.title}
                          </small>
                        </h4>
                        <StParagraphs
                          className="wrap-author-description"
                          dangerouslySetInnerHTML={{
                            __html: htmlbio,
                          }}></StParagraphs>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
          <StCredits>
            <div className="auspicio">
              <div className="col1">
                <span>Con el auspicio de:</span>
              </div>
              <div className="col2">
                <img
                  src="https://minio.lab.ltnext.com/strapi/logo-huawei_ed33725fa4.svg"
                  alt=""
                />
              </div>
            </div>

            <div className="">
              <span>Colaboran</span>
              <br />
              <LogoHeight>
                <div className="logo">
                  <img
                    src="https://minio.lab.ltnext.com/strapi/Image_3_cd68f84fa9.png"
                    alt=""
                  />
                </div>
              </LogoHeight>
            </div>
            <div className="gremios mx-auto max-w-sm">
              <p>
                Agradecemos la colaboración de la Red de Gremios Regionales de
                SOFOFA, en especial a los gremios de CIDERE (Región de Coquimbo)
                y ASIVA (Región de Valparaíso); quienes aportaron su visión
                sobre los desafíos y oportunidades de sus regiones en este
                contexto de pandemia.
              </p>
              <img
                src="https://minio.lab.ltnext.com/strapi/logo-valpo_6e2361a946.png"
                alt=""
              />
            </div>
          </StCredits>
        </div>
        <div className="bg-white pt-4 sm:col-span-4 col-span-12">
          <Banner html={htmlbanner} maxwidth="300px" maxheight="600px" />
        </div>
        <div className="sponsors">
          <Sponsors
            data={sponsors}
            className="block mx-auto p-12"
            childClassName="sm:mx-10 mx-4 my-10"
          />
        </div>
      </div>
    </div>
  )
}

export default Webinar
